module.exports = __webpack_public_path__ + "static/media/cloud-onedrive-icon.e7115c0a.svg";